import { useState, type FormEvent } from 'react';
import { isValidSlug, normalizeSlug, recentTenants, setTenantSlug } from '../lib/tenant.ts';
import { Field, inputCls, btnCls, ErrorText } from './AuthShell.tsx';

/**
 * 조직(테넌트) ID 입력 단계 (CR-013).
 * 조직이 URL(?tenant=)·저장값으로 정해지지 않은 채 인증 화면에 들어오면 AuthShell 이 페이지 내용 대신 이 단계를 보인다.
 * 서버 확인 없이 형식만 검사하고 저장한다. 실제 존재 여부는 다음 단계(이메일 → login/start)에서 드러난다.
 */
export function TenantEntry() {
  const [value, setValue] = useState('');
  const [error, setError] = useState<unknown>(null);
  const recent = recentTenants();

  function submit(e: FormEvent) {
    e.preventDefault(); setError(null);
    const slug = normalizeSlug(value);
    if (!isValidSlug(slug)) { setError(new Error('조직 ID 는 영문 소문자·숫자·하이픈(-)만 쓸 수 있고 2~63자입니다. 하이픈으로 시작하거나 끝날 수 없습니다.')); return; }
    setTenantSlug(slug);
  }

  return (
    <>
      <header className="mb-6">
        <h1 className="text-[22px]! font-semibold! tracking-tight text-slate-900 leading-tight">조직 선택</h1>
        <p className="mt-1.5 text-[13px] text-slate-500 leading-relaxed">로그인할 조직의 ID 를 입력하세요. 초대 메일이나 조직 관리자에게서 확인할 수 있습니다.</p>
      </header>
      <form onSubmit={submit} noValidate>
        <Field label="조직 ID" hint="예: acme · 영문 소문자, 숫자, 하이픈(-)">
          <input
            className={`${inputCls} font-mono`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="your-org"
            autoComplete="organization"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            inputMode="url"
            required
            autoFocus
          />
        </Field>
        <button className={btnCls} disabled={!value.trim()}>계속</button>
        <ErrorText error={error} />
      </form>
      {recent.length > 0 && (
        <div className="mt-6 pt-5 border-t border-slate-100">
          <div className="text-[11.5px] font-medium text-slate-400 mb-2">최근 사용한 조직</div>
          <div className="flex flex-wrap gap-1.5">
            {recent.map((s) => (
              <button key={s} type="button" onClick={() => setTenantSlug(s)} className="inline-flex items-center gap-1.5 h-7 border border-slate-200 bg-slate-50 px-2.5 font-mono text-[12.5px] text-slate-700 hover:border-accent hover:text-accent-strong hover:bg-white">
                <span className="inline-block w-1.5 h-1.5 bg-slate-400" />{s}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
